import { actions, types } from './requests'
export const GETCORP_TYPES = {
    ...types('GETCORP'),
}
export const GETCORP_ACTIONS = {
    ...actions('GETCORP'),
}
